import React from 'react';

const Fader = ({ size = 24 }) => {
  const half = size / 2;

  return (
    <svg
      className="fader"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
    >
      <circle cx={half} cy={half} r="0" fill="currentColor">
        <animate
          attributeName="r"
          begin="0s"
          dur="1.2s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines=".52,.6,.25,.99"
          values="0;11"
        />
        <animate
          attributeName="opacity"
          begin="0s"
          dur="1.2s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines=".52,.6,.25,.99"
          values="1;0"
        />
      </circle>
      <circle cx={half} cy={half} r="0" fill="currentColor">
        <animate
          attributeName="r"
          begin="0.2s"
          dur="1.2s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines=".52,.6,.25,.99"
          values="0;11"
        />
        <animate
          attributeName="opacity"
          begin="0.2s"
          dur="1.2s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines=".52,.6,.25,.99"
          values="1;0"
        />
      </circle>
      <circle cx={half} cy={half} r="0" fill="currentColor">
        <animate
          attributeName="r"
          begin="0.4s"
          dur="1.2s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines=".52,.6,.25,.99"
          values="0;11"
        />
        <animate
          attributeName="opacity"
          begin="0.4s"
          dur="1.2s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines=".52,.6,.25,.99"
          values="1;0"
        />
      </circle>
    </svg>
  );
};

export default Fader;
